export default __webpack_public_path__ + "static/media/locationIcon.0c4bedd3.svg";